import { Component, Vue, Prop } from 'vue-property-decorator';
import UserManagementService from '../UserManagementService';
import WithRender from './UserRegistration.html';
import { Inject } from 'vue-di-container';

import ProviderService from '../../Provider/ProviderService';
import { UserManagementModel } from '../UserManagementModel';
import ValidationService from '../../../Services/ValidationService';
import UserModel from '../../../shared/userService/Model/UserModel';
import UserService from '../../../shared/userService/UserService';
import { UserTypeDropdownModel } from '../UserTypeDropdownModel';
import { Toaster } from '../../../Services/toast';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        UserManagementService,
        ProviderService,
        UserService,
    ],
})
export default class UserRegistration extends Vue {
    @Inject(UserService) public userService!: UserService;
    @Inject(UserManagementService) public userManagementService!: UserManagementService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(ValidationService) public validationService!: ValidationService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ type: String, default: 'Add' })
    public mode: string | any;

    @Prop({ default: '' })
    public id!: string;
    public UserRole: string = '';
    public addUserDialog: boolean = false;
    public editUserDialog: boolean = false;
    public type: number = 0;
    public typeOptions: UserTypeDropdownModel[] = [
        {
            id: 1,
            name: 'Admin',
        },
        {
            id: 2,
            name: 'Provider User',
        },
        {
            id: 3,
            name: 'CST Admin',
        },
        {
            id: 4,
            name: 'CST User',
        },
        {
            id: 5,
            name: 'Provider Admin',
        },
        {
            id: 6,
            name: 'Support',
        },
        {
            id: 7,
            name: 'Service',
        },
        {
            id: 8,
            name: 'Finance',
        },
        {
            id: 10,
            name: 'Monitor',
        },
        {
            id: 11,
            name: 'CST Tag Name',
        },
        {
            id: 14,
            name: 'API User330',
        }
    ];
    public superAdmin: UserTypeDropdownModel = {
        id: 9,
        name: 'Super Admin',
    };
    public managingRequests: UserTypeDropdownModel = {
        id: 15,
        name: 'Managing Requests',
    };
    public fraudManagement: UserTypeDropdownModel = {
        id: 16,
        name: 'Fraud Management',
    };

    public provider: number = 0;

    public providerOptions: any[] = [];

    public userInfo!: UserModel;

    public enableChangeType: boolean = false;

    public user: UserManagementModel = {
        id: '',
        email: '',
        mobileNumber: '',
        operatorName: '',
        providerId: '',
        providerName: '',
        roleId: 0,
        roleName: '',
        username: '',
        isLocked: false,
    };

    public currentUserRoleId: number = 0;
    public showCSTRoleChangeDialog: boolean = false;

    public created() {
        this.$emit('childinit', this.layoutSup);
    }

    public async mounted() {
        this.userInfo = await this.userService.getUser();
        this.UserRole = this.userInfo.details.Role;
        if (this.isEditMode) {
            this.user = await this.userManagementService.GeById(this.id);
            this.currentUserRoleId = this.user.roleId;
        }


        if (this.userInfo.details.Role === 'Provider Admin') {
            this.typeOptions = [
                {
                    id: 2,
                    name: 'Provider User',
                },
                {
                    id: 5,
                    name: 'Provider Admin',
                },
            ];
            if (!this.isEditMode && this.userInfo.details.ProviderId) {
                this.user.providerId = this.userInfo.details.ProviderId;
            }
        }
        if (this.userInfo.details.Role === 'CITC Admin' || this.userInfo.details.Role === 'CITC User') {
            this.typeOptions = [
                {
                    id: 3,
                    name: 'CST Admin',
                },
                {
                    id: 4,
                    name: 'CST User',
                },
            ];
        }

        if (this.userInfo.details.Role === 'Super Admin') {
            this.typeOptions.push(this.superAdmin);
            this.typeOptions.push(this.managingRequests);
            this.typeOptions.push(this.fraudManagement);
        }

        if (this.userInfo.details.Role === 'Super Admin' && this.isEditMode) {
            if (this.user.roleId === 3 || this.user.roleId === 4) {
                this.typeOptions = [
                    { id: 3, name: 'CST Admin' },
                    { id: 4, name: 'CST User' }
                ];
            } else {
                this.typeOptions = [
                    { id: 1, name: 'Admin' },
                    { id: 9, name: 'Super Admin' },
                    { id: 15, name: 'Managing Requests' },
                    { id: 16, name: 'Fraud Management' }
                ];

                if (
                    !this.typeOptions.some(opt => opt.id === this.user.roleId)
                ) {
                    const roleName = this.getRoleNameById(this.user.roleId);
                    this.typeOptions.push({ id: this.user.roleId, name: roleName });
                }
            }
        }

        const response = await this.providerService.Get('', '', '', '', '0', '10000');
        this.providerOptions = response.result;
    }

    public isMobileNumberValid() {
        if (!this.user.mobileNumber.startsWith('5')) {
            Toaster.error(this.$t('shared.InvalidMobileNumber').toString());
        }
    }

    public hideEditUserDialog() {
        this.editUserDialog = false;
    }
    public hideAddUserDialog() {
        this.addUserDialog = false;
    }
    public showEditUser() {
        if ((this.currentUserRoleId === 3 || this.currentUserRoleId === 4) &&
            (this.user.roleId === 3 || this.user.roleId === 4) &&
            this.user.roleId !== this.currentUserRoleId) {
            this.showCSTRoleChangeDialog = true;
        } else {
            this.editUserDialog = true;
        }
    }
    public showAddUser() {
        this.addUserDialog = true;
    }
    public get isEditMode() {
        return (this.mode === 'Edit');
    }

    public get isAccountActive(): boolean {
        return !this.user.isLocked;
    }

    public set isAccountActive(value: boolean) {
        this.user.isLocked = !value;
    }

    public async addUser() {
        this.user.username.trim();
        this.user.email.trim();
        this.user.mobileNumber.trim();
        const response = await this.userManagementService.Post(this.user);
        if (response.isSuccess) {
            this.$router.push({ name: 'UserManagement' });
            Toaster.success(this.$t('shared.AddUsersuccessfully').toString());
        } else {
            Toaster.error(response.errorMessage);
        }
        this.hideAddUserDialog();
    }
    public async editUser() {
        this.user.email.trim();
        this.user.mobileNumber.trim();
        const response = await this.userManagementService.Put(this.user);
        if (response.isSuccess) {
            this.$router.push({ name: 'UserManagement' });
            Toaster.success(this.$t('userManagementPage.EditUserSuccessfully').toString());
        } else {
            Toaster.error(response.errorMessage);
        }
        this.hideEditUserDialog();
    }

    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }

    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }

    public onChangeType() {
        const isEdit = this.isEditMode;
        if (!isEdit) {
            if (this.userInfo && this.userInfo.details && this.userInfo.details.Role === 'Provider Admin'
                && this.userInfo.details.ProviderId) {
                this.user.providerId = this.userInfo.details.ProviderId;
            } else {
                this.user.providerId = '';
            }
        }
    }

    public get isValid(): boolean {
        return (
            (this.isEditMode || (!this.isEditMode && this.user.username.trim() !== ''))
            && (this.isEditMode || (!this.isEditMode && this.user.email.trim() !== ''))
            && (this.isEditMode || (!this.isEditMode &&
                this.validationService.isValidEmail(this.user.email.trim())))
            && this.user.mobileNumber.trim() !== ''
            && this.user.mobileNumber.trim().length === 9
            && this.user.mobileNumber.startsWith('5')
            && (this.isEditMode || (!this.isEditMode && this.user.roleId !== 0))
            && (this.isEditMode || (!this.isEditMode &&
                (this.user.roleId !== 2 || (this.user.roleId === 2 &&
                    this.user.providerId !== ''))))
            && (this.isEditMode || (!this.isEditMode &&
                (this.user.roleId !== 5 || (this.user.roleId === 5 &&
                    this.user.providerId !== ''))))
            && (this.isEditMode || (!this.isEditMode &&
                (this.user.roleId !== 7 || (this.user.roleId === 7 &&
                    this.user.providerId !== ''))))
        );
    }

    get canEditRole() {
        if (!this.isEditMode) return true;
        const isSuperAdmin =
            this.userInfo && this.userInfo.details && this.userInfo.details.Role === 'Super Admin';
        const isCSTTarget = this.currentUserRoleId === 3 || this.currentUserRoleId === 4;

        return !!(isSuperAdmin && isCSTTarget);
    }

    public confirmCSTRoleChange() {
        this.showCSTRoleChangeDialog = false;
        this.editUser();
    }

    public cancelCSTRoleChange() {
        this.showCSTRoleChangeDialog = false;
        this.user.roleId = this.currentUserRoleId;
    }

    public getRoleNameById(id: number): string {
        switch (id) {
            case 1:
                return 'Admin';
            case 2:
                return 'Provider User';
            case 3:
                return 'CST Admin'; 
            case 4:
                return 'CST User'; 
            case 5:
                return 'Provider Admin';
            case 6:
                return 'Support';
            case 7:
                return 'Service';
            case 8:
                return 'Finance';
            case 9:
                return 'Super Admin';
            case 10:
                return 'Monitor';
            case 11:
                return 'Cst Tag Name';
            case 14:
                return 'API User330';
            case 15:
                return 'Managing Requests';
            case 16:
                return 'Fraud Management';
            default:
                return 'Unknown';
        }
    }

}
